import { render, staticRenderFns } from "./DatasetGroupPermissions.vue?vue&type=template&id=316c2a0e&"
import script from "./DatasetGroupPermissions.vue?vue&type=script&lang=js&"
export * from "./DatasetGroupPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports